import { WorkerEmploymentType } from '@types';

export const getPreferredWorkerEmploymentTypeLabel = (
  employmentType: WorkerEmploymentType
): {
  key: string;
  ns: string;
} => {
  switch (employmentType) {
    case 'FREELANCER':
      // t('employment-type.freelancer', { ns: 'web-common' })
      return { key: 'employment-type.freelancer', ns: 'web-common' };
    case 'TEMPWORKER':
      // t('employment-type.tempworker', { ns: 'web-common' })
      return { key: 'employment-type.tempworker', ns: 'web-common' };
    case 'EMPLOYEE':
      // t('employment-type.employee', { ns: 'web-common' })
      return { key: 'employment-type.employee', ns: 'web-common' };
  }
};
